import { Button, ButtonProps } from '../Button';

export const PrimaryButton = ({ children, ...props }: ButtonProps) => {
  return (
    <Button variant="contained" color="primary" {...props}>
      {children}
    </Button>
  );
};
